import { Flex, FormControl, FormErrorMessage, FormLabel, InputProps } from "@chakra-ui/react";
import { useContext, useEffect } from "react";

import { RanaSelectSearch } from "../../../rana-select/components/rana-select-search";
import { RanaFormContext } from "../../rana-form";

import { useRanaFormGeocoderInput } from "./use-rana-form-geocoder-input";

interface RanaFormGeocoderProps extends InputProps {
  field: string;
  maptilerApiKey: string;
  label?: string;
  explanation?: string;
}

export function RanaFormGeocoderInput({
  field,
  maptilerApiKey,
  label,
  explanation,
  isRequired,
  ...rest
}: RanaFormGeocoderProps) {
  const { addRequired } = useContext(RanaFormContext);
  const { geocoderFeatures, searchString, setSearchString, setMaptilerFeature, error, value } =
    useRanaFormGeocoderInput(field, maptilerApiKey);
  useEffect(() => {
    if (isRequired) addRequired(field);
  }, [addRequired, field, isRequired]);

  return (
    <FormControl isRequired={isRequired} isInvalid={!!error}>
      <Flex direction="column">
        <FormLabel>{label}</FormLabel>
        <Flex w="full" alignItems="center" position="relative">
          <RanaSelectSearch
            w="full"
            {...rest}
            isInvalid={!!error}
            placeholder={explanation}
            options={geocoderFeatures.map((feature) => ({
              value: feature.place_name,
            }))}
            searchState={[searchString, setSearchString]}
            onChange={(placeName) => {
              const feature = geocoderFeatures.find((f) => f.place_name === placeName);
              setMaptilerFeature(feature);
            }}
            value={value}
          />
        </Flex>

        <FormErrorMessage>{error}</FormErrorMessage>
      </Flex>
    </FormControl>
  );
}
